import { LicensingPanel } from "@pluginplay/pp-cep-license";
import React from "react";
import ReactDOM from "react-dom";
import { csi, vulcanListen, vulcanSend } from "../lib/utils";
ReactDOM.render(
	<React.StrictMode>
		<LicensingPanel
			csi={csi}
			vulcanListen={vulcanListen}
			vulcanSend={vulcanSend}
		/>
	</React.StrictMode>,
	document.getElementById("root")
);
